module.exports = __webpack_public_path__ + "static/issues-e51201afb4074907a821ae2752cc36a0.png";